import { render, staticRenderFns } from "./LoadContent.vue?vue&type=template&id=43cc594a&scoped=true&"
import script from "./LoadContent.vue?vue&type=script&lang=js&"
export * from "./LoadContent.vue?vue&type=script&lang=js&"
import style0 from "./LoadContent.vue?vue&type=style&index=0&id=43cc594a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc594a",
  null
  
)

export default component.exports